import { InteractionType } from '@lendi/core-constants';

export const INTERACTION_TYPES = [
  {
    label: 'Phone',
    value: InteractionType.Phone,
  },
];
